module.exports = __webpack_public_path__ + "img/kmbmicon.247f48fc.svg";